(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("babylon-mmd-wasm", [], factory);
	else if(typeof exports === 'object')
		exports["babylon-mmd-wasm"] = factory();
	else
		root["BABYLONMMDWASM"] = factory();
})((typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this), () => {
return 